const main_path = '@/pages/user'

const ConsolidationRoutes = [
  {
    path: '/consolidations',
    name: 'ConsolidationList',
    meta: { 
      auth: true, 
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/consolidation/ConsolidationList.vue`)
  },
  // {
  //   path: '/consolidation/create',
  //   name: 'CreateConsolidation',
  //   meta: {
  //     auth: true
  //   },
  //   component: () => import('@/pages/consolidation/NewConsolidation.vue')
  // },
  {
    path: '/consolidations/:id',
    name: 'ShowConsolidation',
    meta: {
      auth: true
    },
    component: () => import('@/pages/consolidation/ShowConsolidation.vue')
  }
]

export default ConsolidationRoutes
